import { EuiButton, EuiCallOut, EuiCheckbox, EuiFlexGroup, EuiFlexItem, EuiFormRow } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import {ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import {ComboProyectosContainer as ComboProyectos} from '../../../components/Combos/Proyectos/container';

const _msgInfo = (<p>Esta función realizará un abono negativo de los <strong>partes seleccionados que se encuentren facturados</strong> y 
creará un nuevo parte con las modificaciones que se indiquen.</p>);

export const AbonoConModificacionScreen = (props)=>{

    const {handleAbonar,estadoPartes,user} = props;

    const {nPartes,nPartesFacturados,nPartesNoFacturados,nPartesConAbono} = estadoPartes;
    const [checkedConfirm, setCheckedConfirm] = useState(false);
    const [sociedad, setSociedad] = useState([]);
    const [proyecto, setProyecto] = useState([]);

    useEffect(()=>{{setCheckedConfirm(false)}},[props])

    const onRealizarAbono = ()=>{
        const data = {idSociedad:sociedad[0].value.toString(), idProyecto:((proyecto!==undefined && proyecto.length>0) ? proyecto[0].value : undefined)}
        handleAbonar(data)
    }

    const PartesNoFacturados = useMemo(()=>{
        return nPartesNoFacturados>0 ?
        (<EuiFlexItem>
            <EuiCallOut iconType={'cross'} size='s' color='danger' title={<p>Error. <strong>({nPartesNoFacturados})</strong> partes sin facturar.</p>}/>
        </EuiFlexItem>)
        : null
    },[nPartesNoFacturados])

    const PartesConAbono = useMemo(()=>{
        return nPartesConAbono>0 ?
        (<EuiFlexItem>
            <EuiCallOut iconType={'cross'} size='s' color='danger' title={<p>Error. <strong>({nPartesConAbono})</strong> partes con abono.</p>}/>
        </EuiFlexItem>)
        : null
    },[nPartesConAbono])

    const isInvalidSociedad = useMemo(() => sociedad===undefined || sociedad.length===0,[sociedad])
    const isInvalidProyecto = useMemo(() => (proyecto===undefined || proyecto.length===0),[proyecto,user]);
    const isDisabledProyecto = useMemo(()=>!isInvalidSociedad,[sociedad]);

    const isDisabledConfirmCheck = useMemo(()=> (nPartesNoFacturados>0 || nPartes===0 || nPartesConAbono>0 || isInvalidSociedad || isInvalidProyecto)
    ,[nPartesNoFacturados, nPartes, nPartesConAbono, isInvalidSociedad, isInvalidProyecto])

    useEffect(()=>{if(isDisabledConfirmCheck){setCheckedConfirm(false)}},[isDisabledConfirmCheck])

    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                    <EuiCallOut size='s' color='warning' title={_msgInfo}/>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGroup direction='column'>
                    <EuiFlexItem>
                        <EuiCallOut iconType={'documentEdit'} size='s' color='success' title={<p><strong>({nPartesFacturados})</strong> partes facturados seleccionados</p>}/>
                    </EuiFlexItem>
                    {PartesNoFacturados}
                    {PartesConAbono}
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGroup>
                    <EuiFlexItem style={{maxWidth:'50%'}}>
                        <EuiFormRow label="Sociedad" isInvalid={isInvalidSociedad} fullWidth>
                            <ComboSociedades fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}} isInvalid={isInvalidSociedad} user={user.dni}/>
                        </EuiFormRow>
                    </EuiFlexItem>
                    <EuiFlexItem style={{maxWidth:'50%'}}>
                        <EuiFormRow label="Proyecto" isInvalid={isInvalidProyecto} fullWidth>
                            <ComboProyectos fullWidth dependency 
                            isDisabled={isDisabledProyecto ? false : true} idSociedad={!isInvalidSociedad ? sociedad[0].value : undefined} 
                            selectedOptions={proyecto} onChange={value => setProyecto(value)} isInvalid={isInvalidProyecto}/>
                        </EuiFormRow>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiCheckbox
                    id={'chk-confirm-abono'}
                    label="Confirmar el proceso de abono"
                    checked={checkedConfirm}
                    disabled={isDisabledConfirmCheck}
                    onChange={(e) => {setCheckedConfirm(e.target.checked)}}
                />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiButton className='btn-abono-screen' size='s' fill isDisabled={!checkedConfirm} onClick={()=>{onRealizarAbono()}}>{`Realizar Abonos`}</EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}